import * as jQuery from 'jquery';
import 'jquery-colorbox';

const ExpandableAreaModal = () => {
	jQuery('.expandableArea__link a').colorbox({
		transition: 'none',
		width: '770px',
		maxWidth: '93.75%',
		maxHeight: '93.75%',
		fixed: true,
		close: '<span>Close</span>',
		className: 'colorbox',
		inline: true,
		href: function(){
			return jQuery(this).closest('.expandableArea').clone();
		}
	});
};

export default ExpandableAreaModal;
